module.exports = __webpack_public_path__ + "static/media/illo_bookmarks.f89f7671.svg";